<template>
  <p class="reviews-count" :class="positionClass">
    <span v-if="count === 0">{{ $t('emptyState.notReviewedYet') }}</span>
    <span v-else>Overall Rating based on <strong>{{ count }} Student reviews</strong></span>
  </p>
</template>

<script>
// One source of truth for the "Overall Rating based on N Student reviews"
// label. Previously the same string lived in two spots in HouseReviewScore.vue
// (desktop hero-left + mobile CTA block) and the copies kept drifting on
// pluralization / wording tweaks. The optional `position` prop preserves the
// `.mobile-reviews-count` CSS hook so the existing layout rules keep working.
// When `count` is 0 (no reviews yet), an explicit empty state is shown instead
// of "Overall Rating based on 0 Student reviews", which reads as broken copy.
export default {
  name: 'ReviewsCountLabel',
  props: {
    count:    { type: Number, default: 0 },
    position: { type: String, default: '' }, // '' (desktop) | 'mobile-reviews-count'
  },
  computed: {
    positionClass() { return this.position; },
  },
};
</script>
